import { createContext } from 'react';

import type { ShareHeadline } from './types';

export const ShareHeadlineContext = createContext<ShareHeadline | undefined>(undefined);
